import React from "react";
import { classNames } from "../../shared/utility";

export default function Input(props) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    type,
    value,
    labelOn,
    error,
    explanation,
    ref,
    labelClass,
    prefix,
    suffix,
    style,
    ...other
  } = props;

  const inputStyle = {
    ...style,
    ...(prefix ? { paddingLeft: "2rem" } : {}),
    ...(suffix
      ? {
          paddingRight: `${Math.max(3, String(suffix).length * 0.55 + 1.5)}rem`,
        }
      : {}),
  };

  return (
    <div className={parentClass ? parentClass : null}>
      {labelOn ? (
        <div className="flex space-x-2 mb-1">
          <label
            htmlFor={name}
            className={classNames(
              labelClass ? labelClass : "text-sm",
              "block font-medium text-[#0F172A]",
            )}
          >
            {label}
          </label>
        </div>
      ) : null}
      <div className="relative">
        {prefix ? (
          <span
            className="pointer-events-none absolute inset-y-0 left-3 z-10 flex items-center text-sm text-[#64748B]"
            aria-hidden="true"
          >
            {prefix}
          </span>
        ) : null}
        <input
          type={type}
          name={name}
          id={name}
          className={classNames(
            className
              ? className
              : "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2 text-sm text-[#0F172A] shadow-sm transition placeholder:text-[#64748B]/70 focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B] sm:max-w-xs md:max-w-full",
            suffix ? "appearance-none" : null,
          )}
          value={value}
          onChange={onChange}
          ref={ref}
          style={inputStyle}
          {...other}
        />
        {suffix ? (
          <span
            className="pointer-events-none absolute inset-y-0 right-3 z-10 flex items-center text-sm font-medium text-[#64748B]"
            aria-hidden="true"
          >
            {suffix}
          </span>
        ) : null}
      </div>
      {error ? (
        <p className="mt-1 text-xs font-medium text-[#DC2626]">{error}</p>
      ) : null}
    </div>
  );
}
